module.exports = __webpack_public_path__ + "img/profile.1a1ce6b3.svg";